module.exports = __webpack_public_path__ + "img/icon_wb.5e09fe3f.png";